"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandListSerializer = void 0;
const player_command_1 = require("./player-commands/player-command");
const js_sha256_1 = require("js-sha256");
const player_bet_command_1 = require("./player-commands/player-bet-command");
const player_hit_command_1 = require("./player-commands/player-hit-command");
const player_stand_command_1 = require("./player-commands/player-stand-command");
const player_double_command_1 = require("./player-commands/player-double-command");
const player_split_command_1 = require("./player-commands/player-split-command");
class CommandListSerializer {
    static getHash(commandList) {
        const output = CommandListSerializer.serializedCommands(commandList);
        return CommandListSerializer.computeHash(output);
    }
    static serializedCommands(commandList) {
        return commandList.map((command) => command.serializeToString()).join("\n");
    }
    static computeHash(output) {
        return js_sha256_1.sha256.create().update(output).hex();
    }
    static moveToCommand(move) {
        function parseMove(input) {
            const parts = input.split(" ");
            const cmdStr = {};
            if (parts.length > 0) {
                cmdStr.command = parts[0];
            }
            if (parts.length > 1) {
                cmdStr.amount = parts[1];
            }
            return cmdStr;
        }
        const cmdStr = parseMove(move);
        if (cmdStr.command === undefined) {
            throw new Error("Invalid move");
        }
        switch (cmdStr.command) {
            case player_command_1.CommandTypes.Bet: {
                if (cmdStr.amount === undefined || isNaN(Number(cmdStr.amount))) {
                    throw new Error("Invalid bet");
                }
                return new player_bet_command_1.PlayerBetCommand(Number(cmdStr.amount));
            }
            case player_command_1.CommandTypes.Hit: {
                return new player_hit_command_1.PlayerHitCommand();
            }
            case player_command_1.CommandTypes.Stand: {
                return new player_stand_command_1.PlayerStandCommand();
            }
            case player_command_1.CommandTypes.Double: {
                return new player_double_command_1.PlayerDoubleCommand();
            }
            case player_command_1.CommandTypes.Split: {
                return new player_split_command_1.PlayerSplitCommand();
            }
            default:
                throw new Error("Invalid move");
        }
    }
}
exports.CommandListSerializer = CommandListSerializer;
